module.exports = __webpack_public_path__ + "img/login1.edf52694.webp";